import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as employeeApi from '../../lib/api/employee';

//결재서 가져오기
const [
  LIST_APPROVAL_LINE,
  LIST_APPROVAL_LINE_SUCCESS,
  LIST_APPROVAL_LINE_FAILURE,
] = createRequestActionTypes('employee/LIST_APPROVAL_LINE');

export const listApprovalLine = createAction(LIST_APPROVAL_LINE);
const listApprovalLineSaga = createRequestSaga(
  LIST_APPROVAL_LINE,
  employeeApi.getApprovalLine,
);

//매출처 결재선 가져오기
const [
  LIST_INVOICE_APPROVAL_LINE,
  LIST_INVOICE_APPROVAL_LINE_SUCCESS,
  LIST_INVOICE_APPROVAL_LINE_FAILURE,
] = createRequestActionTypes('employee/LIST_INVOICE_APPROVAL_LINE');

export const listInvoiceApprovalLine = createAction(LIST_INVOICE_APPROVAL_LINE);
const listInvoiceApprovalLineSaga = createRequestSaga(
  LIST_INVOICE_APPROVAL_LINE,
  employeeApi.getInvoiceApprovalLine,
);

const UNLOAD_APPROVAL_LINE = 'employee/UNLOAD_APPROVAL_LINE';
export const unloadApprovalLine = createAction(UNLOAD_APPROVAL_LINE);

export function* employeeApprovalSaga() {
  yield takeLatest(LIST_APPROVAL_LINE, listApprovalLineSaga);
  yield takeLatest(LIST_INVOICE_APPROVAL_LINE, listInvoiceApprovalLineSaga);
}

const initialState = {
  approvalLines: null,
  invoiceLines: null,
  error: null,
};

const employeeApproval = handleActions(
  {
    [LIST_APPROVAL_LINE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      approvalLines: data.list.map((line) => ({
        id: line.apprUuid,
        apprUuid: line.apprUuid,
        apprNm: line.apprNm, //결재선명
        usrUuid1: line.usrUuid1, //결재자1
        usrUuid1Nm: line.usrUuid1Nm,
        usrUuid1Profile: line.usrUuid1Profile,
        dptNm1: line.dptNm1,
        gradeNm1: line.gradeNm1,
        usrUuid2: line.usrUuid2, //결재자2
        usrUuid2Nm: line.usrUuid2Nm,
        usrUuid2Profile: line.usrUuid2Profile,
        dptNm2: line.dptNm2,
        gradeNm2: line.gradeNm2,
        usrUuid3: line.usrUuid3, //결재자3
        usrUuid3Nm: line.usrUuid3Nm,
        usrUuid3Profile: line.usrUuid3Profile,
        dptNm3: line.dptNm3,
        gradeNm3: line.gradeNm3,
        usrUuid4: line.usrUuid4, //결재자4
        usrUuid4Nm: line.usrUuid4Nm,
        usrUuid4Profile: line.usrUuid4Profile,
        dptNm4: line.dptNm4,
        gradeNm4: line.gradeNm4,
        usrUuid5: line.usrUuid5, //결재자5
        usrUuid5Nm: line.usrUuid5Nm,
        usrUuid5Profile: line.usrUuid5Profile,
        dptNm5: line.dptNm5,
        gradeNm5: line.gradeNm5,
        crtUsr: line.crtUsr,
        crtNm: line.crtNm,
        crtDt: line.crtDt,
      })),
      error: null,
    }),
    [LIST_APPROVAL_LINE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),

    [LIST_INVOICE_APPROVAL_LINE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      invoiceLines: data.list.map((line) => ({
        id: line.apprUuid,
        apprUuid: line.apprUuid,
        apprNm: line.apprNm, //결재선명
        usrUuid1: line.usrUuid1, //결재자1
        usrUuid1Nm: line.usrUuid1Nm,
        usrUuid1Profile: line.usrUuid1Profile,
        dptNm1: line.dptNm1,
        gradeNm1: line.gradeNm1,
        usrUuid2: line.usrUuid2, //결재자2
        usrUuid2Nm: line.usrUuid2Nm,
        usrUuid2Profile: line.usrUuid2Profile,
        dptNm2: line.dptNm2,
        gradeNm2: line.gradeNm2,
        usrUuid3: line.usrUuid3, //결재자3
        usrUuid3Nm: line.usrUuid3Nm,
        usrUuid3Profile: line.usrUuid3Profile,
        dptNm3: line.dptNm3,
        gradeNm3: line.gradeNm3,
        usrUuid4: line.usrUuid4, //결재자4
        usrUuid4Nm: line.usrUuid4Nm,
        usrUuid4Profile: line.usrUuid4Profile,
        dptNm4: line.dptNm4,
        gradeNm4: line.gradeNm4,
        usrUuid5: line.usrUuid5, //결재자5
        usrUuid5Nm: line.usrUuid5Nm,
        usrUuid5Profile: line.usrUuid5Profile,
        dptNm5: line.dptNm5,
        gradeNm5: line.gradeNm5,
        crtUsr: line.crtUsr,
        crtNm: line.crtNm,
        crtDt: line.crtDt,
      })),
      error: null,
    }),
    [LIST_INVOICE_APPROVAL_LINE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),

    [UNLOAD_APPROVAL_LINE]: () => initialState,
  },
  initialState,
);

export default employeeApproval;
